// Integration logos keep their own colours, except those drawn in black ink (Autodesk's), which would
// vanish on a dark menu: in dark mode they're inverted to white, which a single-colour mark survives.
const DARK_INK_LOGOS = ['autodesk-small']
export const logoClass = (icon: string): string =>
  `w-4 h-4${DARK_INK_LOGOS.some((name) => icon.includes(name)) ? ' dark:invert' : ''}`
